import React from 'react';
import { connect } from 'react-redux';
import FooterCollapseView from '../FooterCollapseView/FooterCollapseView';

const DisplayTable = ({ data, nameProduct, detailArr }) => {
  const array = data?.listCliSubDetail?.length > 0 ? data.listCliSubDetail : [detailArr];
  return (
    <div className='container-callAddition'>
      {array.map((item, i) => (
        <div className='table-wrapper'>
          {data?.listCliSubDetail?.length > 0 && <div className='title' key={i}>{item.title}</div>}
          {item.otherPartPrice && item.otherPartPrice !== "0.00" &&
            <div className='title-description'>מורכב מ: <span className='title'> תעריף {window.Config.brand_Name_HE}</span> ע"ס <span>₪{item.cellcomPartPrice}</span> + <span className='title'>תעריף מפעיל</span> אחר ע"ס <span>₪{item.otherPartPrice}</span></div>
          }
          <table key={i}>
            <thead>
              {data?.listCliSubDetail?.length > 0 ?
                <tr>
                  {item.colomnTitle1 && <th>{item.colomnTitle1}</th>}
                  {item.colomnTitle2 && <th>{item.colomnTitle2}</th>}
                  {item.colomnTitle3 && <th>{item.colomnTitle3}</th>}
                  {item.cellcomPartPrice != null && <th>{`סה"כ`}</th>}
                </tr>
                :
                <tr>
                  {detailArr.map((item, index) => (
                    <th key={index}>{item.title}</th>
                  ))}
                  <th>{`סה"כ`}</th>
                </tr>
              }
            </thead>
            <tbody>
              {data?.listCliSubDetail?.length > 0 ?
                <tr>
                  <td>{item.colomn1 ? item.colomn1 : item.colomn2}</td>
                  <td>{item.colomn2 ? item.colomn2 : item.colomn1}</td>
                  <td>{item.colomn3 && <>₪{item.colomn3}</>}</td>
                  <td>
                    {
                      item.amountData &&
                      <> ₪{item.amountData.amount}.{item.amountData.amountAgorot} {item.amountData.isAmountMinus ? '-' : ''} </>
                    }
                  </td>
                </tr>
                :
                <tr>
                  {detailArr.map((item, index) => (
                    <td key={index}>{item.value}</td>
                  ))}
                  {data.amountData && (
                    <td className='amount'>
                      ₪{data.amountData.amount}.{data.amountData.amountAgorot}
                      {data.amountData.isAmountMinus ? '-' : ''}
                    </td>
                  )}
                </tr>

              }
            </tbody>
          </table>
        </div>
      ))}
      <FooterCollapseView detail={data} nameProduct={nameProduct} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  // Add any props needed from state here
});

export default connect(mapStateToProps)(DisplayTable);
